import axios from 'axios';
import { msalInstance } from '../config/msalConfig';

const graphClient = axios.create({
  baseURL: 'https://graph.microsoft.com/v1.0',
  timeout: 10000,
});

const graphScopes = ['User.Read'];

async function getGraphToken(): Promise<string | null> {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) return null;

  try {
    const tokenResponse = await msalInstance.acquireTokenSilent({
      scopes: graphScopes,
      account: accounts[0],
    });
    return tokenResponse?.accessToken ?? null;
  } catch {
    try {
      const tokenResponse = await msalInstance.acquireTokenPopup({
        scopes: graphScopes,
        account: accounts[0],
      });
      return tokenResponse?.accessToken ?? null;
    } catch {
      return null;
    }
  }
}

graphClient.interceptors.request.use(async (config) => {
  const token = await getGraphToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const graphApiService = {
  async getMe(): Promise<Record<string, unknown>> {
    const response = await graphClient.get('/me');
    return response.data;
  },

  async getMyPhoto(): Promise<string | null> {
    try {
      const response = await graphClient.get('/me/photo/$value', {
        responseType: 'arraybuffer',
      });
      const base64 = btoa(
        new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
      );
      return `data:image/jpeg;base64,${base64}`;
    } catch {
      return null;
    }
  },

  async getUserPhoto(userId: string): Promise<string | null> {
    try {
      const response = await graphClient.get(`/users/${userId}/photo/$value`, {
        responseType: 'arraybuffer',
      });
      const base64 = btoa(
        new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
      );
      return `data:image/jpeg;base64,${base64}`;
    } catch {
      return null;
    }
  },
};

export default graphApiService;
